module.exports = __webpack_public_path__ + "static/isa-couverture-0caa670d68893fc98b1e13cfb601adf4.jpg";